// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "ea18f7c553931c12","191": "55e1aac122eb9ce7","396": "e3bec004d6403fbf","460": "ac4556e8cf6cdfca","498": "b716fce34f8b0012","917": "a08bb9e374a5253c","985": "e4855fef83a0270b",}[chunkId] + ".chunk.js"
}